import one from "../../assets/images/slide1.jpg";
import two from "../../assets/images/slide2.jpg";
import three from "../../assets/images/slide3.jpg";
import four from "../../assets/images/slide4.jpg";
import five from "../../assets/images/slide5.jpg";
import six from "../../assets/images/slide6.jpg";
import seven from "../../assets/images/slide7.jpg";
import eight from "../../assets/images/slide8.jpg";
import nine from "../../assets/images/slide9.jpg";
import teen from "../../assets/images/slide10.jpg";
import twelve from "../../assets/images/slide11.jpg";
import thirteen from "../../assets/images/slide12.jpg";
import fourteen from "../../assets/images/slide13.jpg";
import fifteen from "../../assets/images/slide14.jpg";
import sixteen from "../../assets/images/slide15.jpg";
import seventeen from "../../assets/images/slide15.jpg";
import mobile from "../../assets/images/mobile.png";


export const images = [
    { img: one },
    { img: two },
    { img: three },
    { img: four },
    { img: five },
    { img: six },
    { img: seven },
    { img: eight },
    { img: nine },
    { img: teen },
    { img: twelve },
    { img: thirteen },
    { img: fourteen },
    { img: fifteen },
    { img: sixteen },
    { img: seventeen },
];

export const mobiles = { img: mobile }
